/** رمز «حسابات نواة»: بذرة داخل دائرة — النواة التى تنمو منها الحسابات. */
export default function BrandMark() {
  return <img className="logo-mark" src="/brand/nawah-mark.png" alt="" aria-hidden="true" />;
}
